<template>
    <div v-if="isCardDraging" class="animation-text">

        <img :src="animationImg" class="img__24 mr__8"
             :class="{ 'img__28': isDesktop}">

        <markdown class="text-lSemibold"
                  :class="{
                    'title-baseSemibold': isDesktop,
                    'color__raspberry': showDelete,
                    'color__lime': showKeep,
                    'color__aquamarine': showLater,
                    'color__sunset': showDeleteKeepReceiving
                  }"
                  :text="animationText"
        ></markdown>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '../../assets/ENUM'
import Markdown from '../../components/Markdown'

export default {

    name: 'animation-cta-card',

    components: {
        Markdown
    },

    computed: {
        ...Vuex.mapGetters([
            'cardDragDirection',
            'isCardDraging'
        ]),

        showDelete() {
            return this.cardDragDirection === ENUM.DIRECTIONS.LEFT
        },

        showDeleteKeepReceiving() {
            return this.cardDragDirection === ENUM.DIRECTIONS.UP
        },

        showKeep() {
            return this.cardDragDirection === ENUM.DIRECTIONS.RIGHT
        },

        showLater() {
            return this.cardDragDirection === ENUM.DIRECTIONS.DOWN
        },

        animationImg() {
            switch (this.cardDragDirection) {
                case ENUM.DIRECTIONS.LEFT:
                    return '/img/icons/card-block.svg'
                case ENUM.DIRECTIONS.UP:
                    return '/img/icons/card-delete.svg'
                case ENUM.DIRECTIONS.RIGHT:
                    return '/img/icons/card-keep.svg'
                case ENUM.DIRECTIONS.DOWN:
                    return '/img/icons/card-sort-later.svg'
            }
        },

        animationText() {
            switch (this.cardDragDirection) {
                case ENUM.DIRECTIONS.LEFT:
                    return this.$t('cleaning_cards_autodelete')
                case ENUM.DIRECTIONS.UP:
                    return this.$t('cleaning_cards_delete')
                case ENUM.DIRECTIONS.RIGHT:
                    return this.$t('cleaning_cards_keep')
                case ENUM.DIRECTIONS.DOWN:
                    return this.$t('sort_later')
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.animation-text {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    opacity: 0;
    animation: fadeIn 1s forwards;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

</style>
